import { useEffect } from 'react';
import { polyfillCountryFlagEmojis } from 'country-flag-emoji-polyfill';
import flagFontUrl from '@bbkPricingPage/assets/TwemojiCountryFlags.woff2';

let initialized = false;

// Pricing pages have multiple entry points. Initialize where flags are used,
// including editor dialogs and the native currency select.
export const useCountryFlagFont = () => {
  useEffect(() => {
    if (initialized) return;
    polyfillCountryFlagEmojis('Twemoji Country Flags', flagFontUrl);
    initialized = true;
  }, []);
};
